import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import logoSrc from '../assets/ilia-logo.png'

type BrandLogoProps = {
  to?: string
  className?: string
  showText?: boolean
  onClick?: () => void
}

export function BrandLogo({ to = '/', className = '', showText = false, onClick }: BrandLogoProps) {
  const { t } = useTranslation()
  const inner = (
    <>
      <img
        className="brand-logo-img"
        src={logoSrc}
        alt=""
        width={48}
        height={54}
        decoding="async"
      />
      {showText && <span className="brand-text">{t('brand')}</span>}
    </>
  )

  if (to) {
    return (
      <Link to={to} className={`brand ${className}`.trim()} onClick={onClick} aria-label={t('brand')}>
        {inner}
      </Link>
    )
  }

  return <span className={`brand ${className}`.trim()}>{inner}</span>
}
